<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
:root {
  --el-font-family: "IranSansWebFont" !important;
}
* {
  font-family: "IranSansWebFont" !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  direction: rtl;
  unicode-bidi: embed;
}
.v-toast__icon {
  display: none !important;
}

label {
  text-align: right !important;
  font-weight: 600 !important;
}
.el-input__inner {
  background-color: transparent !important;
  border-radius: 8px; /* دلخواه */
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #000 !important;
}
input:-webkit-autofill {
  background-color: transparent !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: #000 !important;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.dashboard-container {
  height: 100vh;
}
.el-button--primary,
.el-switch.is-checked .el-switch__core {
  background: #205685 !important;
  background-color: #205685 !important;
  border: 0 !important;
}
::v-deep(a:hover, a) {
  text-decoration: none !important;
}
/* برای زمانی که input فوکوس شده */
.el-input__inner:focus,
.el-input.is-focus .el-input__inner {
  outline: none !important;
  box-shadow: none !important;
  border-color: initial !important; /* یا رنگ دلخواه */
}
/* متن راست‌چین ولی آیکن‌ها سمت چپ */
input {
  text-align: right !important; /* متن داخل input راست‌چین */
  direction: rtl;
}
.report-dropdown .el-select-dropdown__item {
  padding: 0 !important;
}
::v-deep(.report-dropdown .el-select-dropdown__item ){
  padding: 0 !important;
}
 .option-row span {
    font-size: 80%;
}
.el-card__body {
    padding-right: 10px!important;
    padding-left: 10px!important;
}
</style>
